import { HdBodygraphCenter } from './hd-bodygraph.models';

/**
 * Inline SVG markup for each center shape, stripped of hardcoded `fill`
 * presentation attributes so CSS can control fill/stroke via
 * `var(--center-icon-fill)`.  The shape element carries no fill attr —
 * the CSS rule on `.hd-center-mini-card__shape-icon svg *` applies the
 * appropriate fill based on the `variant` modifier class on the host.
 */
/** Standaard-sizing voor een center-icoon: hoogte van de container, breedte volgt. */
export const HD_CENTER_ICON_SVG_STYLE = 'display:block;width:auto;height:100%';

/**
 * Center-shape als SVG-string met fill/stroke en sizing in de markup gebakken.
 * Een via `[innerHTML]` geïnjecteerde SVG krijgt de emulated style-encapsulation
 * niet, dus scoped CSS bereikt hem nooit; vandaar inline. Gedeeld door alle
 * center-iconen (mini-kaartjes, transit-kaarten, cheat sheets, ...).
 */
export function buildHdCenterShapeSvg(
  center: HdBodygraphCenter,
  shapeAttributes: string,
  svgStyle: string = HD_CENTER_ICON_SVG_STYLE,
): string {
  return HD_CENTER_SHAPE_SVG[center]
    .replace('<svg ', `<svg style="${svgStyle}" `)
    .replace('<rect ', `<rect ${shapeAttributes} `)
    .replace('<path ', `<path ${shapeAttributes} `);
}

export const HD_CENTER_SHAPE_SVG: Record<HdBodygraphCenter, string> = {
  hart: `<svg width="92" height="91" viewBox="0 0 92 91" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9.47536 75.1817C0.422194 73.2019 -3.0928 62.1641 3.14836 55.3138L49.957 3.9361C56.1982 -2.91426 67.5146 -0.439476 70.3266 8.3907L91.4167 74.6171C94.2287 83.4472 86.4272 92.0102 77.3741 90.0303L9.47536 75.1817Z"/>
</svg>`,

  solarplexus: `<svg width="84" height="94" viewBox="0 0 84 94" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5.99999 57.0512C-2.00001 52.4324 -2 40.8854 6 36.2666L66 1.62561C74 -2.99319 84 2.78031 84 12.0179V81.3C84 90.5376 74 96.3111 66 91.6923L5.99999 57.0512Z"/>
</svg>`,

  zelf: `<svg width="129" height="129" viewBox="0 0 129 129" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="64.5" y="-4.98401" width="98.2648" height="98.2648" rx="12" transform="rotate(45 64.5 -4.98401)"/>
</svg>`,

  milt: `<svg width="84" height="94" viewBox="0 0 84 94" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M78 57.0512C86 52.4324 86 40.8854 78 36.2666L18 1.62561C9.99999 -2.99319 0 2.78031 0 12.0179V81.3C0 90.5376 10 96.3111 18 91.6923L78 57.0512Z"/>
</svg>`,

  ajna: `<svg width="94" height="84" viewBox="0 0 94 84" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M36.2659 78C40.8847 86 52.4317 86 57.0505 78L91.6915 18C96.3103 9.99999 90.5368 0 81.2992 0H12.0172C2.77957 0 -2.99392 10 1.62488 18L36.2659 78Z"/>
</svg>`,

  hoofd: `<svg width="94" height="84" viewBox="0 0 94 84" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M36.2659 5.99999C40.8847 -2.00001 52.4317 -2 57.0505 6L91.6915 66C96.3103 74 90.5368 84 81.2992 84H12.0172C2.77957 84 -2.99392 74 1.62488 66L36.2659 5.99999Z"/>
</svg>`,

  root: `<svg width="98" height="98" viewBox="0 0 98 98" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="98" height="98" rx="12"/>
</svg>`,

  sacraal: `<svg width="98" height="98" viewBox="0 0 98 98" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="98" height="98" rx="12"/>
</svg>`,

  keel: `<svg width="98" height="98" viewBox="0 0 98 98" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="98" height="98" rx="12"/>
</svg>`,
};
